import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.promise.js';
import 'core-js/modules/es.date.now.js';
import 'core-js/modules/es.date.to-string.js';
import 'core-js/modules/es.object.assign.js';
import { v4 } from 'uuid';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.starts-with.js';
import 'core-js/modules/es.array.map.js';
import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.object.keys.js';
import 'core-js/modules/es.parse-int.js'; // Loading script from CloudFront CDN

var MAIN_SCRIPT_DOMAIN = "https://js.verygoodvault.com"; // Loading script from Fastly CDN

var BACKUP_SCRIPT_DOMAIN = "https://js3.verygoodvault.com";
var VGS_COLLECT_KEEPER = "https://vgs-collect-keeper.apps.verygood.systems";
var SESSION_ID = /*#__PURE__*/v4();
var DEFAULT_CONFIG = {
  vaultId: '',
  environment: 'sandbox',
  version: 'canary'
};
var ANALYTICS_EVENTS = {
  // Script loaded from npm module
  LOADED_FROM_PACKAGE: 'LoadedFromPackage',
  // Script loaded
  SCRIPT_LOAD: 'ScriptLoad',
  // VGSCollect instance is undefined
  INSTANCE_UNDEFINED: 'InstanceUndefined'
};
var ERROR_MESSAGE = {
  IS_REQUIRED: function IS_REQUIRED(value) {
    return value + " is required.";
  },
  IS_UNDEFINED: function IS_UNDEFINED(value) {
    return value + " is undefined.";
  },
  IS_INVALID: function IS_INVALID(value) {
    return value + " is invalid.";
  },
  UNABLE_TO_FIND: function UNABLE_TO_FIND(value) {
    return "Unable to find " + value;
  },
  SCRIPT_WAS_NOT_LOADED: 'VGS Collect.js script was not loaded.',
  CHANGE_VERSION: 'Please explicitly set locked VGS Collect.js version before going live. Check out the changelog https://www.verygoodsecurity.com/docs/vgs-collect/js/changelog'
};
var config = DEFAULT_CONFIG;

var setConfig = function setConfig(params) {
  if (params) {
    config = Object.assign({}, params);
  }
};

var getConfig = function getConfig() {
  return config;
};

var configSchema = {
  vaultId: function vaultId(value) {
    return typeof value === 'string' && /^tnt.{8}$/.test(value);
  },
  environment: function environment(value) {
    return typeof value === 'string' && /^(sandbox|live)((-eu|-ap)-\d{1})?$/.test(value);
  },
  version: function version(value) {
    return value === 'canary' || typeof value === 'string' && /^\d{1,2}\.\d{1,2}(\.\d{1,2})?$/.test(value) && !value.startsWith('1.');
  },
  integrity: function integrity(value) {
    return value ? typeof value === 'string' : true;
  },
  crossorigin: function crossorigin(value) {
    return value ? typeof value === 'string' : true;
  }
};

var isRequired = function isRequired(param) {
  throw new Error(ERROR_MESSAGE.IS_REQUIRED(param));
};

var validate = function validate(schema, obj) {
  if (schema) {
    var errors = Object.keys(schema).filter(function (key) {
      return !schema[key](obj[key]);
    }).map(function (key) {
      return new Error(ERROR_MESSAGE.IS_INVALID(key));
    });

    if (errors.length) {
      var error = errors[0];
      throw error;
    }
  }
};

var validateConfig = function validateConfig(config) {
  validate(configSchema, config);
};

var registerScriptLoading = function registerScriptLoading(params) {
  validateConfig(params);
  setConfig(params);
  trackEvent({
    type: ANALYTICS_EVENTS.LOADED_FROM_PACKAGE
  });
};

var trackEvent = function trackEvent(event) {
  var _getConfig = getConfig(),
      vaultId = _getConfig.vaultId,
      environment = _getConfig.environment,
      version = _getConfig.version;

  var payload = '';
  var data = {
    env: environment,
    tnt: vaultId,
    userAgent: window.navigator.userAgent,
    version: version,
    timestamp: Date.now(),
    vgsCollectSessionId: SESSION_ID
  };

  try {
    payload = window.btoa(JSON.stringify(Object.assign({}, event, data)));
  } catch (err) {
    return;
  }

  fetch(VGS_COLLECT_KEEPER + "/vgs", {
    method: 'POST',
    body: payload
  }).then(function () {
    return true;
  })["catch"](function () {
    return true;
  });
};

var appendElement = function appendElement(elem) {
  var target = document.head || document.body;

  if (!target) {
    throw new Error(ERROR_MESSAGE.UNABLE_TO_FIND('document.head or document.body'));
  }

  target.appendChild(elem);
  return elem;
};

var appendLink = function appendLink(rel, href) {
  var link = document.createElement('link');
  link.rel = rel;
  link.href = href;
  appendElement(link);
};

var parseVersionString = function parseVersionString(version) {
  var parts = version.split('.');
  var major = parseInt(parts[0]) || 0;
  var minor = parseInt(parts[1]) || 0;
  var patch = parseInt(parts[2]) || 0;
  return {
    major: major,
    minor: minor,
    patch: patch
  };
};

var isVersionGreater = function isVersionGreater(current, minimal) {
  if (current === 'canary') return true;
  var currentParsed = parseVersionString(current);
  var minimalParsed = parseVersionString(minimal);

  if (currentParsed.major !== minimalParsed.major) {
    return currentParsed.major > minimalParsed.major;
  }

  if (currentParsed.minor !== minimalParsed.minor) {
    return currentParsed.minor > minimalParsed.minor;
  }

  if (currentParsed.patch !== minimalParsed.patch) {
    return currentParsed.patch > minimalParsed.patch;
  }

  return false;
};

var scriptURL = MAIN_SCRIPT_DOMAIN;

var scriptExists = function scriptExists() {
  try {
    var scripts = document.querySelectorAll("script[src^=\"" + scriptURL + "/vgs-collect/\"]");
    return scripts.length > 0;
  } catch (e) {
    return false;
  }
};

var appendScript = function appendScript() {
  var _getConfig = getConfig(),
      vaultId = _getConfig.vaultId,
      environment = _getConfig.environment,
      version = _getConfig.version,
      integrity = _getConfig.integrity,
      crossorigin = _getConfig.crossorigin;

  var script = document.createElement('script');
  script.src = scriptURL + "/vgs-collect/" + version + "/vgs-collect.js?sessionId=" + SESSION_ID + "&tenantId=" + vaultId + "&env=" + environment;

  if (integrity) {
    script.integrity = integrity;
  }

  if (typeof crossorigin === 'string') {
    script.crossOrigin = crossorigin;
  }

  appendElement(script);
  return script;
};

var loadScript = function loadScript(loadMainCDN) {
  if (loadMainCDN === void 0) {
    loadMainCDN = true;
  }

  var collectPromise = new Promise(function (resolve, reject) {
    var _getConfig2 = getConfig(),
        version = _getConfig2.version;

    if (scriptExists() && window.VGSCollect) {
      resolve(window.VGSCollect);
    } // Fastly fallback CDN is available starting Collect.js version 2.3.0


    if (!loadMainCDN && isVersionGreater(version, '2.3.0')) {
      scriptURL = BACKUP_SCRIPT_DOMAIN;
    }

    if (!window.VGSCollect) {
      var script = appendScript();

      if (script) {
        script.onload = function () {
          if (!window.VGSCollect) {
            trackEvent({
              type: ANALYTICS_EVENTS.INSTANCE_UNDEFINED,
              status: 'OK',
              mainCDN: loadMainCDN
            });
            reject(ERROR_MESSAGE.IS_UNDEFINED('VGS Collect'));
          }

          trackEvent({
            type: ANALYTICS_EVENTS.SCRIPT_LOAD,
            status: 'OK',
            mainCDN: loadMainCDN
          });
          resolve(window.VGSCollect);
        };

        script.onerror = function () {
          trackEvent({
            type: ANALYTICS_EVENTS.SCRIPT_LOAD,
            status: 'Failed',
            mainCDN: loadMainCDN
          });

          if (loadMainCDN) {
            // Load script from backup CDN
            resolve(loadScript(false));
          } else {
            reject(ERROR_MESSAGE.SCRIPT_WAS_NOT_LOADED);
          }
        };
      }
    }
  });
  return collectPromise;
};

var initCollect = function initCollect(vaultId, environment) {
  window.VGSCollect.init = function (callback) {
    if (callback === void 0) {
      callback = function callback() {};
    }

    return window.VGSCollect.create(vaultId, environment, callback);
  };
};

var preFetch = function preFetch() {
  appendLink('dns-prefetch', MAIN_SCRIPT_DOMAIN);
  appendLink('dns-prefetch', BACKUP_SCRIPT_DOMAIN);
};

var preConnect = function preConnect() {
  appendLink('preconnect', MAIN_SCRIPT_DOMAIN);
  appendLink('preconnect', BACKUP_SCRIPT_DOMAIN);
}; // side effects


Promise.resolve().then(function () {
  if (typeof window !== 'undefined' && !window.VGSCollect) {
    // DNS lookup
    preFetch(); // Establish connection to the server

    preConnect();
  }
});

var loadVGSCollect = function loadVGSCollect(config) {
  if (config === void 0) {
    config = isRequired('config');
  }

  var _config = config,
      _config$vaultId = _config.vaultId,
      vaultId = _config$vaultId === void 0 ? isRequired('vaultId') : _config$vaultId,
      _config$environment = _config.environment,
      environment = _config$environment === void 0 ? DEFAULT_CONFIG.environment : _config$environment,
      _config$version = _config.version,
      version = _config$version === void 0 ? DEFAULT_CONFIG.version : _config$version,
      integrity = _config.integrity,
      crossorigin = _config.crossorigin;

  if (version === 'canary') {
    console.warn(ERROR_MESSAGE.CHANGE_VERSION);
  }

  registerScriptLoading({
    vaultId: vaultId,
    environment: environment,
    version: version,
    integrity: integrity,
    crossorigin: crossorigin
  });
  return new Promise(function (resolve, reject) {
    if (typeof window === 'undefined') {
      reject(ERROR_MESSAGE.IS_UNDEFINED('window'));
      return;
    }

    if (window.VGSCollect) {
      initCollect(vaultId, environment);
      resolve(window.VGSCollect);
    }

    loadScript().then(function () {
      initCollect(vaultId, environment);
      resolve(window.VGSCollect);
    })["catch"](function (e) {
      reject(e);
      return;
    });
  });
};

export { loadVGSCollect };